import { c as _c } from "react/compiler-runtime";
import React from 'react';
function renderAlertIcon({
  size
}: {
  readonly size: number;
}): React.JSX.Element {
  const viewBoxDimensions = size * 4;
  return <svg height={size} viewBox={`0 0 ${viewBoxDimensions} ${viewBoxDimensions}`} width={size} xmlns="http://www.w3.org/2000/svg">
      <path d="M17.7 41.6L48 11.2l-5-4.8-25.3 25.4L4.8 18.9 0 23.7l17.7 17.8z" />
    </svg>;
}
export function CopyToClipboardAlert(t0) {
  const $ = _c(11);
  const {
    isVisible,
    message,
    dismiss
  } = t0;
  let t1;
  if ($[0] !== dismiss) {
    t1 = t2 => {
      const {
        size
      } = t2;
      return <button className="button-unstyled alert-icon alert-dismiss" type="button" onClick={dismiss}><svg height={size} viewBox={`0 0 ${size * 4} ${size * 4}`} width={size} xmlns="http://www.w3.org/2000/svg"><path d="M3.7 48L0 44.3 20.3 24 0 3.7 3.7 0 24 20.3 44.3 0 48 3.7 27.7 24 48 44.3 44.3 48 24 27.7 3.7 48z" /></svg></button>;
    };
    $[0] = dismiss;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const renderAlertDismissButton = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="icon"><span className="alert-icon">{renderAlertIcon({
          size: 12
        })}</span></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== message) {
    t3 = <div className="message">{message}</div>;
    $[3] = message;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== renderAlertDismissButton) {
    t4 = <div className="action">{renderAlertDismissButton({
        size: 12
      })}</div>;
    $[5] = renderAlertDismissButton;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isVisible || $[8] !== t3 || $[9] !== t4) {
    t5 = <div className="alert success copy-to-clipboard" data-alert-is-visible={isVisible}>{t2}{t3}{t4}</div>;
    $[7] = isVisible;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
export default CopyToClipboardAlert;